import React, { useEffect, useState, useRef } from 'react';
import parse from 'html-react-parser';
import { getCmsByLanguageAndCode } from './services';
import styles from './CmsContainer.module.scss';
import { usePluginStore } from 'react-pluggable';
import { CAREER } from '../../shared/constants/cms-codes.constants';
import CareerUploadResumeForm from '../../components/fixcenter-career/fixcenter-career';
import { formContainerHtmlId } from '../../components/fixcenter-career/fixcenter-career.service';

function getCms(code: string, languageCode: string): Promise<any> {
    return getCmsByLanguageAndCode(code, languageCode);
}


export default function CmsContainer(props: any) {
    const [cmsObject, setCmsObject] = useState<string>();
    const pluginStore: any = usePluginStore();
    let Renderer = pluginStore.executeFunction("Renderer.getRendererComponent");
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const savedLanguageCode = localStorage.getItem('lang');

        if (savedLanguageCode) {
            getCms(props.code, savedLanguageCode).then((response: any) => {
                setCmsObject(response.data);
            });
        }
    }, [props.code]);

    useEffect(() => {
        if (props.forwardedRef && containerRef.current) {
            if (typeof props.forwardedRef === 'function') {
                props.forwardedRef(containerRef.current);
            }
        }
    }, [props.forwardedRef]);

    return (
        <div className={styles.main_container}>
            {parse(cmsObject ? cmsObject : "")}
            {props.code === CAREER && <div id={formContainerHtmlId}><CareerUploadResumeForm/></div>}
        </div>
    )
}
